export function parseSettings(data) {
    if (!data.settings) {
        return [];
    }
    return data.settings.map(function (setting) { return ({
        name: setting.setting_name,
        value: setting.setting_value,
    }); });
}
//# sourceMappingURL=parseSettings.js.map